﻿/**
 * portal-admin-quicklinks.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-admin-quicklinks.controller', portalAdminQuickLinksController);

	/** setup injection */
	portalAdminQuickLinksController.$inject = ['toastr', 'portal-quick-link.repository', 'portal-link.repository'];

	/** implementation */
	function portalAdminQuickLinksController(toastr, portalQuickLinkRepo, portalLinkRepo) {
		/** pubic properties */
		var vm = this;
		vm.quicklinks = [];
		vm.portalLink = [];
		vm.selectedPortalLink = null;

		/** public methods */
		vm.addQuickLink = addQuickLink;
		vm.removeQuickLink = removeQuickLink;
		vm.reorder = reorder;

		/** run init */
		init();

		/** public method implementations */

		/** add a quick link */
		function addQuickLink() {
			/** get the last quick link for the order number */
			var orderNumber = 1;
			var last = _.last(vm.quicklinks);
			if (last) orderNumber = last.orderNumber + 1;

			/** create the quick link object */
			var quicklink = {
				'portalQuickLinkID': 0,
				'portalLinkID': vm.selectedPortalLink,
				'orderNumber': orderNumber
			};

			/** save the quick link */
			portalQuickLinkRepo.post(quicklink).then(function() {
				/** reload quick links */
				loadQuickLinks().then(function() {
					/** adjust the portal links again */
					adjustPortalLinks();
				});

				/** show success message */
				toastr.success('Quick link added successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });

				/** reset selected link */
				vm.selectedPortalLink = null;
			});
		}

		/** remove a quick link */
		function removeQuickLink(quicklink) {
			/** send the request */
			portalQuickLinkRepo.remove(quicklink.portalQuickLinkID).then(function() {
				/** reload quick links */
				loadQuickLinks().then(function() {
					/** adjust the portal links again */
					adjustPortalLinks();
				});

				/** show success message */
				toastr.success('Quick link removed successfully.', 'Removal Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** reorder the quicklinks */
		function reorder() {
			/** set the order number value */
			angular.forEach(vm.quicklinks, function(ql, index) {
				ql.orderNumber = (index + 1);
			});

			/** save quicklinks */
			portalQuickLinkRepo.reorder(vm.quicklinks).then(function() {
				/** show success message */
				toastr.success('Quick Links reordered successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** load the quick links */
			loadQuickLinks().then(function() {
				/** load the portal links */
				portalLinkRepo.getAll().then(function(portalLinks) {
					/** add a visible flag */
					_.forEach(portalLinks, function(pl) {
						pl.portalLinkName = pl.portalLinkName.stripHtml();
						pl.visible = true;
					});

					/** set links */
					vm.portalLinks = portalLinks;

					/** adjust the portal links */
					adjustPortalLinks();
				});
			});
		}

		/** load quicklinks */
		function loadQuickLinks() {
			/** send request */
			return portalQuickLinkRepo.getAll().then(function(quicklinks) {
				/** set quick links */
				vm.quicklinks = quicklinks;
			});
		}

		/** adjust the available links */
		function adjustPortalLinks() {
			/** get the portalLinkIDs of the quick links */
			var portalLinkIDs = _.map(vm.quicklinks, function(ql) {
				return ql.portalLinkID;
			});

			/** go through portal links to show / hide */
			_.forEach(vm.portalLinks, function(pl) {
				pl.visible = !portalLinkIDs.contains(pl.portalLinkID);
			});
		}
	}
})();